import { ArrowLeft, Info, Home } from "lucide-react";
import { ZONE_CONFIG } from "./ZoneHeroCards";

export const ZoneDetailHeader = ({ zone, count, language, t, onBack }) => {
  const config = ZONE_CONFIG[zone];
  if (!config) return null;
  const Icon = config.icon;
  const name = language === "pl" ? config.name_pl : config.name_en;

  return (
    <div className="relative">
      {/* Hero banner */}
      <div className="relative h-36 overflow-hidden">
        <img
          src={config.image}
          alt={name}
          className="w-full h-full object-cover"
        />
        <div className={`absolute inset-0 bg-gradient-to-t ${config.gradient}`} />
        <div className="absolute inset-0 bg-black/20" />

        {/* Back button */}
        <button
          data-testid="back-to-zones-btn"
          onClick={onBack}
          aria-label={t.back_home}
          className="absolute top-3 left-3 min-w-[44px] min-h-[44px] w-11 h-11 rounded-full bg-black/40 backdrop-blur-md flex items-center justify-center text-white hover:bg-black/60 transition-colors"
        >
          <ArrowLeft size={18} />
        </button>

        {/* Back to homepage */}
        <button
          data-testid="back-home-btn"
          onClick={onBack}
          aria-label={t.back_home}
          className="absolute top-3 right-3 min-h-[44px] px-4 rounded-full bg-black/40 backdrop-blur-md flex items-center gap-1.5 text-white text-xs font-semibold hover:bg-black/60 transition-colors"
        >
          <Home size={14} />
          {t.back_home}
        </button>

        {/* Zone title overlay */}
        <div className="absolute bottom-3 left-4 right-4 flex items-end justify-between">
          <div className="flex items-center gap-2">
            <div className={`w-8 h-8 rounded-lg ${config.accent} flex items-center justify-center`}>
              <Icon size={16} className="text-white" />
            </div>
            <div>
              <h2 className="text-white text-lg font-bold leading-tight">{name}</h2>
            </div>
          </div>
        </div>
      </div>

      {/* Deposit note (SnackBar only) */}
      {zone === "kiosk" && (
        <div
          data-testid="deposit-note"
          className="mx-4 mt-3 flex items-start gap-2 bg-amber-50 border border-amber-200 rounded-xl px-3 py-2.5"
        >
          <Info size={14} className="text-amber-600 shrink-0 mt-0.5" />
          <p className="text-xs text-amber-800 leading-snug">{t.deposit_note}</p>
        </div>
      )}
    </div>
  );
};
